import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { A11yModule } from '@angular/cdk/a11y';
import { IonicModule } from '@ionic/angular';

import { TimeTypeinPageRoutingModule } from './time-typein-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { TimeTypeinPage } from './time-typein.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, A11yModule, TimeTypeinPageRoutingModule, TranslateModule.forChild()],
  declarations: [TimeTypeinPage]
})
export class TimeTypeinPageModule {}
